module.exports = __webpack_public_path__ + "static/media/emergency.404d3e93.svg";